import React from "react";
import logo from "../../assets/site_logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <footer className="container-fluid footer_section ds-instrument p-0">
        <div className="container">
          <div className="row pt-5 pb-1">
            <div className="col-md-6 mb-4">
              <div className="footer_left_area">
                <img src={logo} className="footer_logo" alt="Duct Sizer Pro" />
                {/* <p className="my-4">On the other hand, we denounce with righteous indignation and dislike men who
                        are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by
                        desire, that they cannot foresee the pain and.</p> */}
                {/* <div className="footer_socail_area">
    <a href="https://twitter.com/" target="_blank" className='footerLinks'>
        <i className="fa-brands fa-twitter"></i>
    </a>
    <a href="https://www.facebook.com/" target="_blank" className='footerLinks'>
        <i className="fa-brands fa-facebook-f"></i>
    </a>
    <a href="https://linkedin.com/" target="_blank" className='footerLinks'>
        <i className="fa-brands fa-linkedin-in"></i>
    </a>
</div> */}
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="footer_right_area">
                <h2>Contact Info</h2>
                {/* <p className="my-3">On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment.</p> */}
                <div className="contact_info">
                  {/* <div> <i className="fa-solid fa-envelope"></i> mechanicalcalculator@gmail.com </div> */}
                  <div>
                    {" "}
                    <i className="fa-solid fa-envelope"></i>{" "}
                    <a
                      href="mailto:admin@ductsizerpro.com"
                      className="footerLinks2"
                    >
                      admin@ductsizerpro.com
                    </a>{" "}
                  </div>
                  {/* <div> <i className="fa-solid fa-phone"></i> <a href='' className='footerLinks2'> 012-924-533 </a></div> */}
                  {/* <div> <i className="fa-solid fa-location-dot"></i> USA</div> */}
                  <div>
                    <i className="fa-solid fa-location-dot"></i>{" "}
                    <a
                      //href="https://www.google.com/maps/place/United+States"
                      className="footerLinks2"
                    >
                      Sydney-Australia
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row footer_copy_right_section">
          <p>DS.PRO &copy; {currentYear}</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
